"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesSonarObjectsGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../../sonar-objects/_idMap/actions.js");
exports.coreInitiativesSonarObjectsGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successDataActionCreators: [
            (response) => (0, actions_1.updateSonarObjectReferences)(response.results.map((result) => ({
                displayName: result.displayName,
                isActive: !result.isVanished,
                isDeleted: result.isVanished,
                parentDisplayName: result.parentDisplayName,
                parentSonarObjectId: result.parentSonarObjectId,
                relatedCounts: result.relatedCounts,
                sonarObjectId: result.sonarObjectId,
                sonarObjectType: result.sonarObjectType,
                statusId: result.sonarObjectStatusId,
                tags: [...result.tagIds],
                versionNumber: result.versionNumber
            })))
        ]
    },
    name: name_1.CoreInitiativesSonarObjectsName,
    receive: true,
    request: true,
    requestHandler: _api_1.getInitiativeSonarObjects,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map